import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'evi-desktop-unauthorized-view',
  templateUrl: './unauthorized-view.component.html',
  styleUrls: ['./unauthorized-view.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorizedViewComponent {
}
